// Smoothly animates the open/close transition of .accordion details elements
// (FAQ, How to Use, Ingredients) using the Web Animations API. Falls back to
// native instant toggle if JS doesn't run.
// Guarded against double-binding: this script is loaded by both
// main-product.liquid and product-faq.liquid when both are on the page.
document.querySelectorAll('.accordion details').forEach((details) => {
  if (details.dataset.accordionBound) return;
  details.dataset.accordionBound = 'true';

  const summary = details.querySelector('summary');
  const content = details.querySelector('.accordion__content');
  if (!summary || !content) return;

  let animation = null;
  let isClosing = false;
  let isExpanding = false;

  summary.addEventListener('click', (event) => {
    event.preventDefault();
    details.style.overflow = 'hidden';

    if (isClosing || !details.open) {
      open();
    } else if (isExpanding || details.open) {
      shrink();
    }
  });

  function shrink() {
    isClosing = true;
    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (animation) animation.cancel();
    animation = details.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease-in-out' });
    animation.onfinish = () => onAnimationFinish(false);
    animation.oncancel = () => (isClosing = false);
  }

  function open() {
    details.style.height = `${details.offsetHeight}px`;
    details.open = true;
    window.requestAnimationFrame(() => expand());
  }

  function expand() {
    isExpanding = true;
    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

    if (animation) animation.cancel();
    animation = details.animate({ height: [startHeight, endHeight] }, { duration: 300, easing: 'ease-in-out' });
    animation.onfinish = () => onAnimationFinish(true);
    animation.oncancel = () => (isExpanding = false);
  }

  function onAnimationFinish(isOpen) {
    details.open = isOpen;
    animation = null;
    isClosing = false;
    isExpanding = false;
    details.style.height = details.style.overflow = '';
  }
});
